import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_099486f0 from 'nuxt_plugin_plugin_099486f0' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_3130186c from 'nuxt_plugin_sentryserver_3130186c' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_fca2fb7c from 'nuxt_plugin_sentryclient_fca2fb7c' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_1b540bd8 from 'nuxt_plugin_plugin_1b540bd8' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_74166dae from 'nuxt_plugin_cookieuniversalnuxt_74166dae' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_toast_fc743296 from 'nuxt_plugin_toast_fc743296' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_workbox_2867a5a2 from 'nuxt_plugin_workbox_2867a5a2' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_fccbaa96 from 'nuxt_plugin_metaplugin_fccbaa96' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_f37c5fae from 'nuxt_plugin_iconplugin_f37c5fae' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_184360f5 from 'nuxt_plugin_pluginutils_184360f5' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_6a20f600 from 'nuxt_plugin_pluginrouting_6a20f600' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_6460f322 from 'nuxt_plugin_pluginmain_6460f322' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_gtm_4fbdab48 from 'nuxt_plugin_gtm_4fbdab48' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_libplugin77c17b3c_54bfb5c1 from 'nuxt_plugin_libplugin77c17b3c_54bfb5c1' // Source: ./lib.plugin.77c17b3c.js (mode: 'all')
import nuxt_plugin_axios_94d4cbf4 from 'nuxt_plugin_axios_94d4cbf4' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_nuxtapollomodule_7a66bc1c from 'nuxt_plugin_nuxtapollomodule_7a66bc1c' // Source: ./nuxt-apollo-module.js (mode: 'all')
import nuxt_plugin_datefns_315d1a06 from 'nuxt_plugin_datefns_315d1a06' // Source: ./date-fns.js (mode: 'all')
import nuxt_plugin_nuxtpluginec6a6ec8_4b3acf95 from 'nuxt_plugin_nuxtpluginec6a6ec8_4b3acf95' // Source: ./nuxt.plugin.ec6a6ec8.js (mode: 'all')
import nuxt_plugin_bugsnag_4aea807c from 'nuxt_plugin_bugsnag_4aea807c' // Source: ../plugins/bugsnag (mode: 'all')
import nuxt_plugin_axios_630a4306 from 'nuxt_plugin_axios_630a4306' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_bodyscrolllock_0ed59419 from 'nuxt_plugin_bodyscrolllock_0ed59419' // Source: ../plugins/body-scroll-lock (mode: 'client')
import nuxt_plugin_directives_f60b4746 from 'nuxt_plugin_directives_f60b4746' // Source: ../plugins/directives (mode: 'all')
import nuxt_plugin_validation_b46593c6 from 'nuxt_plugin_validation_b46593c6' // Source: ../plugins/mixins/validation (mode: 'all')
import nuxt_plugin_smoothscroll_5fd40a14 from 'nuxt_plugin_smoothscroll_5fd40a14' // Source: ../plugins/smoothscroll (mode: 'client')
import nuxt_plugin_lazysizes_4201e7b6 from 'nuxt_plugin_lazysizes_4201e7b6' // Source: ../plugins/lazysizes (mode: 'client')
import nuxt_plugin_vcalendar_16d9fd0e from 'nuxt_plugin_vcalendar_16d9fd0e' // Source: ../plugins/v-calendar (mode: 'client')
import nuxt_plugin_vidle_2095a9a4 from 'nuxt_plugin_vidle_2095a9a4' // Source: ../plugins/v-idle (mode: 'client')
import nuxt_plugin_libnuxtclientinitpluginclient7c635451_b519905a from 'nuxt_plugin_libnuxtclientinitpluginclient7c635451_b519905a' // Source: ./lib.nuxt-client-init.plugin.client.7c635451.js (mode: 'client')
import nuxt_plugin_auth_1e60932c from 'nuxt_plugin_auth_1e60932c' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_meta_9c06062c from 'nuxt_plugin_meta_9c06062c' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Examenbank","titleTemplate":(t) => {
      return t + (t === 'Examenbank' ? '' : ' – Examenbank');
    },"htmlAttrs":{"lang":"nl"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"description","hid":"description","content":""},{"name":"apple-mobile-web-app-title","hid":"apple-mobile-web-app-title","content":"Examenbank"},{"name":"og:title","hid":"og:title","content":"Examenbank"},{"name":"og:description","hid":"og:description","content":""},{"name":"og:site_name","hid":"og:site_name","content":"Examenbank"}],"link":[{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Open+Sans&display=swap"}],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_099486f0 === 'function') {
    await nuxt_plugin_plugin_099486f0(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_3130186c === 'function') {
    await nuxt_plugin_sentryserver_3130186c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_fca2fb7c === 'function') {
    await nuxt_plugin_sentryclient_fca2fb7c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_1b540bd8 === 'function') {
    await nuxt_plugin_plugin_1b540bd8(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_74166dae === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_74166dae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_fc743296 === 'function') {
    await nuxt_plugin_toast_fc743296(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_2867a5a2 === 'function') {
    await nuxt_plugin_workbox_2867a5a2(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_fccbaa96 === 'function') {
    await nuxt_plugin_metaplugin_fccbaa96(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_f37c5fae === 'function') {
    await nuxt_plugin_iconplugin_f37c5fae(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_184360f5 === 'function') {
    await nuxt_plugin_pluginutils_184360f5(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_6a20f600 === 'function') {
    await nuxt_plugin_pluginrouting_6a20f600(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_6460f322 === 'function') {
    await nuxt_plugin_pluginmain_6460f322(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_4fbdab48 === 'function') {
    await nuxt_plugin_gtm_4fbdab48(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin77c17b3c_54bfb5c1 === 'function') {
    await nuxt_plugin_libplugin77c17b3c_54bfb5c1(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_94d4cbf4 === 'function') {
    await nuxt_plugin_axios_94d4cbf4(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtapollomodule_7a66bc1c === 'function') {
    await nuxt_plugin_nuxtapollomodule_7a66bc1c(app.context, inject)
  }

  if (typeof nuxt_plugin_datefns_315d1a06 === 'function') {
    await nuxt_plugin_datefns_315d1a06(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtpluginec6a6ec8_4b3acf95 === 'function') {
    await nuxt_plugin_nuxtpluginec6a6ec8_4b3acf95(app.context, inject)
  }

  if (typeof nuxt_plugin_bugsnag_4aea807c === 'function') {
    await nuxt_plugin_bugsnag_4aea807c(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_630a4306 === 'function') {
    await nuxt_plugin_axios_630a4306(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bodyscrolllock_0ed59419 === 'function') {
    await nuxt_plugin_bodyscrolllock_0ed59419(app.context, inject)
  }

  if (typeof nuxt_plugin_directives_f60b4746 === 'function') {
    await nuxt_plugin_directives_f60b4746(app.context, inject)
  }

  if (typeof nuxt_plugin_validation_b46593c6 === 'function') {
    await nuxt_plugin_validation_b46593c6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_smoothscroll_5fd40a14 === 'function') {
    await nuxt_plugin_smoothscroll_5fd40a14(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazysizes_4201e7b6 === 'function') {
    await nuxt_plugin_lazysizes_4201e7b6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vcalendar_16d9fd0e === 'function') {
    await nuxt_plugin_vcalendar_16d9fd0e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vidle_2095a9a4 === 'function') {
    await nuxt_plugin_vidle_2095a9a4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_libnuxtclientinitpluginclient7c635451_b519905a === 'function') {
    await nuxt_plugin_libnuxtclientinitpluginclient7c635451_b519905a(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_1e60932c === 'function') {
    await nuxt_plugin_auth_1e60932c(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_9c06062c === 'function') {
    await nuxt_plugin_meta_9c06062c(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
